import {DBBase} from './DBBase';

export class DBPartners extends DBBase {
    /**
     * @param {Object} component
     */
    constructor(component) {
        super(
            component,
            '/partners'
        );
    }

    approve() {
        this.request('/approve');
    }
}
